import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IDivision } from "src/models/Products/Division.models";

interface DivisionState {
  divisions: IDivision[];
  divisionToEdit: IDivision | null;
}

const initialState: DivisionState = {
  divisions: [],
  divisionToEdit: null,
};

const DivisionSlice = createSlice({
  name: "Division",
  initialState,
  reducers: {
    setDivisionList: (state, action: PayloadAction<IDivision[]>) => {
      state.divisions = action.payload;
    },
    concatListDivision: (
      state: DivisionState,
      action: PayloadAction<IDivision[]>
    ) => {
      state.divisions = [...state.divisions.concat(action.payload)];
    },
    setDivisionToEdit: (state, action: PayloadAction<IDivision | null>) => {
      state.divisionToEdit = action.payload;
    },
    addDivision: (state, action: PayloadAction<IDivision>) => {
      state.divisions.push(action.payload);
    },
    addDivisions: (state, action: PayloadAction<IDivision[]>) => {
      state.divisions.push(...action.payload);
    },
    updateDivision: (state, action: PayloadAction<IDivision>) => {
      let itemIndex = state.divisions.findIndex(
        item => item.divisionId === action.payload.divisionId
      );
      if (itemIndex !== -1) state.divisions[itemIndex] = action.payload;
    },
    deleteDivision: (state, action: PayloadAction<number>) => {
      const newArray = state.divisions.filter(
        item => item.divisionId !== action.payload
      );
      state.divisions = newArray;
    },
  },
});

export const {
  setDivisionList,
  concatListDivision,
  setDivisionToEdit,
  addDivision,
  addDivisions,
  updateDivision,
  deleteDivision,
} = DivisionSlice.actions;

export default DivisionSlice.reducer;
